import { TableBody, TableRow } from '@mui/material';
import { useSelector } from 'react-redux';
import { getAllBranch } from './redux.selectors';
import TableCellContainer from '@libComponents/table/TableCellContainer';
import TableContainer from '@libComponents/table/TableContainer';
import TableHeaderContainer from '@libComponents/table/TableHeaderContainer';
import { ContentContainer } from '@libComponents/ContentContainer';
import { Button } from '@libComponents';
import dayjs from 'dayjs';
import { DeleteOutline } from '@mui/icons-material';
import EditIcon from '@mui/icons-material/EditOutlined';


export default function ViewBranch({ setViewType, setData }) {
    const tableRows = useSelector((state) => getAllBranch(state));
    const TABLE_DATA = {
        'name': 'Name',
        'city': 'City',
        'country': 'Country',
        'address': 'Address',
        'emails': 'Emails',
        'contacts': 'Contacts',
    };

    const handleEdit = (row) => {
        setViewType('createBranch');
        setData({ mode: 'update', row });
    }

    const handleDelete = (row) => {
        setViewType('deleteBranch');
        setData({ row });
    }

    if (!tableRows) return null;
    return (
        <ContentContainer
            title='Branch'
            sx={{ border: 0, p: "0 !important", mb: 0 }}
            AdornmentComponent={
                <Button
                    onClick={() => {
                        setViewType('createBranch');
                        setData({ mode: 'create', row: {} });
                    }}
                >
                    Add branch
                </Button>
            }
        >
            <TableContainer sx={{ p: "0 !important" }}>
                <TableHeaderContainer>
                    {Object.values(TABLE_DATA).map((th, i) => (
                        <TableCellContainer typography='caption' key={th}>
                            {th}
                        </TableCellContainer>
                    ))}
                    <TableCellContainer typography='caption' key="action" align="right">
                        Actions
                    </TableCellContainer>
                </TableHeaderContainer>
                <TableBody>
                    {tableRows.map((row, i) => (
                        <TableRow key={i}>
                            {Object.keys(TABLE_DATA).map((key, index) => {
                                let columnData = row[key];
                                switch (key) {
                                    case 'startTime':
                                        return (
                                            <TableCellContainer key={key}>
                                                {dayjs(columnData).format("HH:mm")}
                                            </TableCellContainer>
                                        )
                                    case 'endTime':
                                        return (
                                            <TableCellContainer key={key}>
                                                {dayjs(columnData).format("HH:mm")}
                                            </TableCellContainer>
                                        )
                                    default:
                                        return (
                                            <TableCellContainer key={key}>
                                                {columnData}
                                            </TableCellContainer>
                                        )
                                }
                            })}
                            <TableCellContainer
                                align='right'
                            >
                                <EditIcon
                                    onClick={() => { handleEdit(row) }}
                                    sx={{ cursor: 'pointer', opacity: 0.75 }}
                                />
                                <DeleteOutline
                                    sx={{ cursor: 'pointer', opacity: 0.5 }}
                                    onClick={() => { handleDelete(row) }}
                                />
                            </TableCellContainer>
                        </TableRow>
                    ))}
                </TableBody>
            </TableContainer>
        </ContentContainer>
    );
}
